import { render } from "./TestIntroduction.vue?vue&type=template&id=11b23cb8&scoped=true"
import script from "./TestIntroduction.vue?vue&type=script&lang=js"
export * from "./TestIntroduction.vue?vue&type=script&lang=js"

import "./TestIntroduction.vue?vue&type=style&index=0&id=11b23cb8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11b23cb8"]])

export default __exports__